<template>
  
    <div class="file-input-div">
      <!-- <div class="file-input-label">
      <img src="/assets/images/file.svg" alt />
      <span class="top-label-text">{{label}}</span>
      <span class="bottom-label-text">{{fileTypes}}</span>
      <a class="bottom-label-text" href="/assets/file/repayment.csv" target="_blank">
        <img class="download-img" src="/assets/images/download.svg" alt="download" />Download sample payment schedule
      </a>
      </div>-->
      <b-form-file  :disabled="disabled" accept=".jpg, .png, .gif" multiple v-model="inputVal" plain></b-form-file>
      <div class="file-input-background">
        <!-- <img v-if="!isLoading" src="/assets/images/Cloud-upload.svg" alt /> -->
        <img
          :style="{width:'20px',height:'auto'}"
          v-if="isLoading"
          src="/assets/images/page-ring-loader.svg"
          alt="loader"
        />
        <div class="previews" v-if="previewURLs.length>0">
          <template v-for="(item,index) in previewURLs">
            <!-- <span :key="index">{{ item.name ? item.name : `Drag & Drop to ${label}` }}</span> -->
            <div :key="index" class="preview-wrapper">
              <img class="preview-img" :src="item" alt />
              <span @click="deleteItem(index,item)" class="icon">
                <b-icon-x-circle-fill />
              </span>
            </div>
          </template>
        </div>
        <template v-else>
          <span>{{`Drag & Drop to ${label}`}}</span>
          <p class="subtext">
            or
            <span>browse</span> to select a jpg/png/jpeg file
          </p>
        </template>
      </div>
      <template v-for="(error,index) in  errors">
        <p class="text-danger error-text" :key="index">{{`${error.name} ${error.message}`}}</p>
      </template>
      <template v-for="(item,index) in progress">
        <n-progress
          :key="index"
          v-if="item.progress && item.progress>0"
          :value="item.progress"
          :type="item.progress===100? 'success': 'warning'"
          :height="15"
        >{{item.name}}</n-progress>
      </template>
    </div>
  
</template>

<script>
import { Progress } from "@/components";
import { BIconXCircleFill } from "bootstrap-vue";
//import { ValidationProvider } from "vee-validate";
export default {
  components: {
    [Progress.name]: Progress,
    BIconXCircleFill,
    //ValidationProvider
  },
  data() {
    return {
      file: null,
      files: [],
      errors:[]
    };
  },
  props: {
    onfile: Function,
    label: String,
    fileTypes: String,
    value: Array,
    isLoading: Boolean,
    progress: Array,
    deleteUrl: Function,
    deleteFile: Function,
    preview: {
      type: Array,
      default: () => {
        return [];
      }
    },
    editing: { type: Boolean, default: false },
    max: { type: Number, default: 20 }
  },
  methods: {
    updateFiles64(files) {
      this.files = files;
    },
    deleteItem(index, item) {
      if (
        item.includes("https://firebasestorage.googleapis.com/v0/b/smart-menu")
      ) {
        this.deleteUrl(item);
      } else {
        const fileIndex = this.files.find(x => x.data === item).index;
        this.deleteFile(fileIndex, item);
      }
    },
    getInvalidImageType(files){
      const invalidFiles=files.filter(file=>!file.type.includes("image"))
      invalidFiles.map(file=>this.errors.push({name:file.name,message:"is not a valid file "}))
    },
    getInvalidImageSize(files){
      const invalidFiles=files.filter(file=>file.size>2097152)
      invalidFiles.map(file=>this.errors.push({name:file.name,message:"is larger than 2MB "}))
    },
    validateFile(files){
      this.getInvalidImageType(files)
      this.getInvalidImageSize(files)
      const validFiles=files.filter(file=>file.type.includes("image")&&file.size<=2097152)
      
      return validFiles
    }
  },
  computed: {
    inputVal: {
      get() {
        const files = [];
        this.value.map((file, index) => {
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            if (reader.result) {
              files.push({ index, data: reader.result });
            }
          };
        });
        this.updateFiles64(files);
        return this.value;
      },
      set(val) {
        if (this.previewURLs.length + val.length <= this.max) {
          this.$emit("changed", this.validateFile(val));
        } else {
          alert(`maximum of ${this.max} files`);
        }
      }
    },
    disabled() {
      return this.previewURLs.length === this.max;
    },
    previewURLs() {
      const fileData = this.files.map(item => item.data);
      return [...this.preview, ...fileData];
    }
  }
};
</script>

<style >
.file-input-div {
  position: relative;
}

.form-control-file {
  position: absolute;
  top: 0px;
  left: 0;
  opacity: 0;
  height: 89px;
  cursor: pointer;
}

.form-control-file:focus + .file-input-background {
  border: 1px #007bff solid;
}

.file-input-background {
  width: 100%;
  height: 89px;
  text-align: center;
  border: 1px solid #cccccc;
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.file-input-background .previews {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.previews .preview-wrapper {
  position: relative;
  margin: 0 10px;
}

.previews .preview-wrapper .icon {
  position: absolute;
  top: -15px;
  right: 0px;
  color: black;
  font-size: medium;
}

.previews .preview-img {
  width: 80px;
  border-radius: 5px;
}

.file-input-background > img {
  display: block;
  margin: 0 auto;
  width: 18px;
  height: 21px;
}

.file-input-background span {
  display: block;
  font-size: 12px;
  color: #898989;
  font-weight: 600;
}

.file-input-label {
  height: 35px;
}

.file-input-label img {
  float: left;
  height: 25px;
  width: 32px;
  margin-top: 5px;
}

.file-input-label .top-label-text {
  color: #424242;
  font-size: 14px;
  display: block;
  font-weight: 400;
}

.file-input-label .bottom-label-text {
  color: #27be58;
  font-size: 11px;
  display: block;
  margin-top: -3px;
}

.subtext {
  font-size: 10px;
  color: #898989;
  display: flex;
  justify-content: center;
}

.subtext span {
  color: #27be58 !important;
  margin: 0 5px;
  font-size: 10px !important;
}
.download-img {
  margin-right: 5px;
  width: 10px !important;
  height: 10px !important;
}

.error-text{
  font-size: 8px;
  font-weight: 500;
}
</style>
